// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { ButtonType, ButtonVariant } from "@toolkit/Framework/Types/Button";
import { buttonThemeStyles, focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export const buttonStyles = (type: ButtonType, isAltText?: boolean /* Store Custom Code */) => {
    return css`
        ${focusStyles()}
        ${buttonDisabledStyles(type)}
        /* Store Removed - min-width */
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        transition: ${transitionHoverStyles("color", "background-color", "border-color")};
        letter-spacing: 1px; /* Store Custom Code */

        ${({ theme }) => `
            font-weight: ${theme.design.typography.weight.semibold /* Store Custom Code */};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        /* Store Custom Code - Start */
        ${({ theme }) => {
            if (isAltText) {
                return css`
                    text-transform: none;
                    letter-spacing: 0;
                    font-weight: ${theme.design.typography.weight.bold};

                    > ${TypographyStyle} {
                        font-size: 1.2em;
                    }
                `;
            }
        }}
        /* Store Custom Code - End */

        [class*="ButtonIcon"] {
            top: 0;
            height: 1em;
            color: inherit;
            transition: ${transitionHoverStyles("color")};

            svg {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate3d(-50%, -50%, 0);
            }
        }
    `;
};

export const buttonDisabledStyles = (type: ButtonType) => {
    switch (type) {
        case "solid":
            return css`
                &:disabled {
                    background-color: ${getColor("button.disabled")};
                    border-color: ${getColor("button.disabled")};
                    color: ${getColor("button.disabled.contrast")};
                }
            `;
        case "outline":
        case "mixed": // Store Custom Code
            return css`
                &:disabled {
                    background-color: ${getColor("button.disabled") /* Store Custom Code */};
                    border-color: ${getColor("button.disabled")};
                    color: ${getColor("button.disabled.contrast") /* Store Custom Code */};
                }
            `;
        default:
            break;
    }
};

export const buttonResetStyles = (resetHover = true) => {
    return css`
        ${focusStyles()}
        min-width: 0;
        min-height: 0;
        padding: 0;
        border: 0;
        border-radius: 0;
        background-color: transparent;
        text-transform: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;

        ${resetHover
            ? css`
                  &:hover,
                  &:active {
                      background-color: transparent;
                  }
              `
            : null}

        ${TypographyStyle} {
            font-size: inherit;
            font-weight: inherit;
        }

        ${IconWrapper} {
            color: inherit;
        }
    `;
};

export const buttonFieldIconStyles = () => {
    return css`
        ${({ theme }) => {
            if (theme.design.button.field.enabled) {
                const scale = 1 + theme.design.button.field.scaling;
                const align = 50 * (1 - theme.design.button.field.scaling);

                return css`
                    &:not(#important) {
                        top: 50%;
                        left: 50%;
                        right: auto;
                        display: block;
                        width: auto;
                        height: auto;
                        padding: 0;
                        background-color: transparent;
                        color: inherit;
                        line-height: 0;
                        transform: scale(${scale}) translate3d(-${align}%, -${align}%, 0);
                    }
                `;
            }
        }}
    `;
};

export const buttonFieldIconClickableStyles = (variant?: ButtonVariant) => {
    return css`
        ${({ theme }) => {
            if (theme.design.button.field.enabled) {
                return css`
                    &:not(#important) {
                        ${buttonThemeStyles(variant)}
                        min-width: auto;
                        border: 0;

                        ${({ theme }) => css`
                            ${focusStyles(true)}
                            transform: scale(${1 - theme.design.button.field.scaling});
                        `}
                    }
                `;
            }
        }}
    `;
};
